

export function isIframed() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}